// extracted by mini-css-extract-plugin
module.exports =  {"carbonTabsContainer":"carbonTabsContainer_EEkHFDTt","content":"content_P9xEZeVz"};